import { useRequest } from 'ahooks'
import { getDashboardWorktimeAPI } from '@/services'
import { toHsl, parseTime } from '@/utils'
import Cost from "./cost"

export interface BudgetDataItem{
    xLabel: string,
    yValue: number,
}

export interface DataItemPos {
    xLabel: string,
    yValue: number,
    isToday: boolean,
    isAfter: boolean,
    date?: XDate
}
export interface YDataItem{
    hide?: boolean,
    user: API.Project.User,
    color: string,
    data: DataItemPos[]
}
export interface XDate{
    label: string,
    isToday: boolean,
    isAfter: boolean,
    startDate: string,
    endDate: string,
    dateLabel?: string
}
export interface WorktimeData{
    xDates: XDate[]
    yData: YDataItem[]
    min: number
    max: number
    today?: XDate,
    todayData: API.Project.TodayPopDataItem[]
}
interface WorktimeOption{
    onSuccess: (d: WorktimeData) => void
}
export const useWorktime = (projectID: number | string, {
    onSuccess
}: WorktimeOption) => {
    const getWorktimeData = (projectID: number | string) => {
        return new Promise<WorktimeData>(async (resolve, reject) => {
            try {
                const res = await getDashboardWorktimeAPI(projectID)
                const curDate = new Date()
                curDate.setHours(0, 0, 0, 0)
                const xDates: XDate[] = (res.dates || []).map(v => {
                    const start = new Date(v.startDate)
                    start.setHours(0, 0, 0, 0)
                    const end = new Date(v.endDate)
                    end.setHours(0, 0, 0, 0)
                    const today = curDate >= start && curDate <= end
                    const label = parseTime(start, "{m}月{d}日") + " - " + parseTime(end, "{m}月{d}日")
                    return {
                        ...v,
                        
                        isToday: today,
                        isAfter: start > curDate,
                        label: label,
                        dateLabel: label
                    }
                })
                let min: number, max: number
                res.monthlyTrendData.forEach(v => {
                    if (min == null) {
                        min = v.taskCount
                    } else {
                        min = Math.min(min, v.taskCount)
                    }
                    if (max == null) {
                        max = v.taskCount
                    } else {
                        max = Math.max(max, v.taskCount)
                    }
                })

                let yData = (res.members || []).map(v => {
                    const memberData = res.monthlyTrendData.filter(item => item.userID === v.id).map(item => {
                        const date = xDates.find(date => date.startDate === item.startDate)
                        return {
                            xLabel: date?.label || "",
                            isToday: !!date?.isToday,
                            isAfter: !!date?.isAfter,
                            yValue: item.taskCount,
                            date: date
                        }
                    })
                    return {
                        user: v,
                        color: toHsl(v.lastname || v.firstname),
                        data: memberData
                    }
                })
                const todayData = res.targetData || []
                todayData.sort((a, b)=>b.taskCount - a.taskCount)
                resolve({
                    todayData: todayData,
                    xDates,
                    yData,
                    min: min!,
                    max: max!,
                    today: xDates.find(v=>v.isToday)
                })
            } catch (error) {
                reject()
            }
        })
    }
    const { data } = useRequest(getWorktimeData, {
        defaultParams: [projectID],
        onSuccess: (d)=>onSuccess(d)
    })

    return {
        data
    }
}


export { Schedule } from "./schedule"
export { Worktime } from "./worktime"
export { Efficiency } from "./efficiency"

export {
    Cost
}
